<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: transparent;
}

//.monitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('mujurukudan') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1d1d24' : '#000355', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#33333A' : '#151599', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }" cell-class-name="cell-class-name">
        <el-table-column :label="$t('mujurukudanhao')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.no) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mojubianhao')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mould.no) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mujubianma')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mould.code) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mojumingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mould.name) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('rukuleixing')">
          <template slot-scope="scope">
            <div style="font-weight: bold;font-size: 12px;border-radius: 2px;height: 30px;width: 100px;display: flex;justify-content: center;align-items: center;border:1px solid rgba(255, 58, 94, 1)" :style="{ color: textColor[scope.row.type], 'border-color': textColor[scope.row.type], 'background-color': bgColor[scope.row.type] }">
              {{ $t(store.state.dictJsonAll['MOULD_IN_WAREHOUSING_TYPE'][scope.row.type]) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chuangjianren')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.createByObject ? scope.row.createByObject.nickname : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chuangjianshijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ dayjs.unix(scope.row.createTime / 1000).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('shifouxuyaobaoyang')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.maintain ? $t('shi') : $t('fou') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('baoyangzhuangtai')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.maintain ? $t(maintainMap[scope.row.maintain.status]) : $t('weibaoyang') }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('shifouxuyaowixiu')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.repair ? $t('shi') : $t('fou') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mujuweixiuzhaungtai')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.repair ? $t(repairMap[scope.row.repair.status]) : $t('weiweixiu') }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_model_manage_in_repairing',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      textColor: { '1': 'rgba(255, 58, 94, 1)', '2': 'rgba(255, 200, 58, 1)', '3': 'rgba(57, 241, 109, 1)', '4': 'rgba(57, 241, 109, 1)', '5': 'rgba(57, 241, 109, 1)' },
      bgColor: { '1': 'rgba(255, 58, 94, 0.2)', '2': 'rgba(255, 200, 58, 0.2)', '3': 'rgba(57, 241, 109, 0.2)', '4': 'rgba(57, 241, 109, 0.2)', '5': 'rgba(57, 241, 109, 0.2)' },
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list: [],
      maintainMap: {
        0: 'weibaoyang',
        1: 'baoyangzhong',
        2: 'yiwancheng'
      },
      repairMap: {
        0: 'daichuli',
        1: 'chulizhong',
        2: 'yiwancheng'
      },

      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/web/mould/in/bill/page?pageNum=1&pageSize=9999&&status=1', {
        params: {
          orderBy: 'createTime desc'
          //orgId: this.$attrs.orgId,
        }
      });
      this.list = response.data.rows;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 4;
      }, 800);
    }
  }
};
</script>
